import React from "react";
import { ArrayInput, SimpleFormIterator, TextInput } from "react-admin";
import { Grid } from "@material-ui/core";

export const AgentConfigForm = () => {
  return (
    <Grid container item direction="column" spacing={1} lg={12}>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={12} md={6}>
          <ArrayInput source="altNames" label="Alt Names">
            <SimpleFormIterator disableReordering>
              <TextInput
                source=""
                label="Alt Name"
                variant="outlined"
                fullWidth
                helperText={false}
              />
            </SimpleFormIterator>
          </ArrayInput>
        </Grid>
      </Grid>
    </Grid>
  );
};
